import { ScItem, ShortPhraseFields } from '@/types/sitecore';
import utils from '@/utils/index';
export const getRatioVal = (ratio?: string | null) => {
  if (!ratio) return undefined;
  const temp = ratio.split('_').map((val) => Number(val.trim()));
  return temp[0] / (temp[1] ?? 1);
};
export const getGridRange = (field?: ScItem<ShortPhraseFields>) => {
  const val = utils.sp.getVal(field);
  if (!val) return undefined;
  const temp = val.split('_').map((val: string) => Number(val.trim()));
  return [temp[0], temp[1] ?? 12];
};
